import React from 'react';
import Button from './button';
import arrow from './../../assets/tiltedarrow.svg';

import './category.css'
const CategoryCard = (props) => {
    return ( <>
    <div className="categoryCard">
        <img className='img' src={props.img} alt="" />
        <div className="btnTitleFlex">
            {props.title}
        <Button img={arrow} class=" btn3" />
        </div>
    </div>
    
    </> );
}
 
export default CategoryCard;